/**
 * Created by vladislav on 18/10/2022
 */

const SpecialEnergyOffer = function () {

};

SpecialEnergyOffer.prototype.load = function (data) {
    data = data || {};

    if (typeof data[this.expedition] === "object") {
        data[this.expedition] = data[this.expedition].show;
    }

    data[this.expedition] = data[this.expedition] || 0;

    this.data = data;
};

SpecialEnergyOffer.prototype.init = function () {
    this.showPlacement = false;

    this.expedition = cleverapps.meta.selectedLocationId();

    this.load(cleverapps.dataLoader.load(DataLoader.TYPES.SPECIAL_LIVES_OFFER_LAST_TIME));

    this.onPurchaseFinished = function () {};

    this.refreshIcon();
};

SpecialEnergyOffer.prototype.refreshIcon = function () {
    const icon = cleverapps.sideBar.getIconByClassName(SpecialEnergyOfferIcon);
    if (icon) {
        icon.resetState();
    } else if (this.getIconLeftTime() > 0) {
        cleverapps.sideBar.addTemporaryIcon(new SpecialEnergyOfferIcon());
    }
};

SpecialEnergyOffer.prototype.wantsToShow = function () {
    if (cleverapps.focusManager.isFocused()) {
        this.showPlacement = true;
    } else {
        this.displayWindow();
    }
};

SpecialEnergyOffer.prototype.save = function (time) {
    this.data[this.expedition] = time || Date.now();

    cleverapps.dataLoader.save(DataLoader.TYPES.SPECIAL_LIVES_OFFER_LAST_TIME, this.data);
};

SpecialEnergyOffer.prototype.getNextTime = function () {
    return this.getData() + cleverapps.parseInterval(SpecialEnergyOffer.TIMEOUT);
};

SpecialEnergyOffer.prototype.getIconLeftTime = function () {
    const availableUntil = this.getData() + cleverapps.parseInterval(SpecialEnergyOffer.ICON_DURATION);
    return Math.max(0, availableUntil - Date.now());
};

SpecialEnergyOffer.prototype.getData = function () {
    return this.data[this.expedition] || 0;
};

SpecialEnergyOffer.prototype.isReady = function () {
    if (!Merge2.current) {
        return false;
    }

    return cleverapps.user.checkAvailable(cleverapps.config.availables.SPECIAL_ENERGY_OFFER) && this.getNextTime() <= Date.now();
};

SpecialEnergyOffer.prototype.displayWindow = function () {
    if (cleverapps.lives.showForce()) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "SpecialEnergyOfferWindow",
        action: function (f) {
            this.save();
            this.refreshIcon();
            new SpecialEnergyOfferWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });
};

SpecialEnergyOffer.prototype.getProduct = function () {
    return Product.CreateByHardPrice(this.getPrice(), {
        type: "special_offer",
        expedition: cleverapps.meta.selectedLocationId()
    });
};

SpecialEnergyOffer.prototype.getPrice = function () {
    return SpecialEnergyOffer.ENERGY_PRICE;
};

SpecialEnergyOffer.prototype.getEnergyAmount = function () {
    return SpecialEnergyOffer.ENERGY_AMOUNT;
};

SpecialEnergyOffer.prototype.getPriceTag = function () {
    return this.getProduct().getCurrentPrice();
};

SpecialEnergyOffer.prototype.buy = function () {
    const product = this.getProduct();

    if (product) {
        product.buy(this.processBought.bind(this), { noRewardWindow: true });
    }
};

SpecialEnergyOffer.prototype.refreshAfterBought = function () {
    this.save(Date.now() - cleverapps.parseInterval(SpecialEnergyOffer.ICON_DURATION));
    this.refreshIcon();
};

SpecialEnergyOffer.prototype.processBought = function (success) {
    if (!success) {
        this.onPurchaseFinished(false);
        return;
    }

    this.refreshAfterBought();

    cleverapps.metrics.logEvent(cleverapps.EVENTS.SPENT.GENIE_ENERGY);

    cleverapps.focusManager.display({
        focus: "SpecialEnergyOfferReward",
        stack: true,
        action: (f) => {
            new RewardWindow({
                energy: this.getEnergyAmount()
            }, {
                event: cleverapps.EVENTS.EARN.GENIE
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });

    this.onPurchaseFinished(true);
};

SpecialEnergyOffer.RestoreFind = function () {
    return Merge2.current ? cleverapps.specialEnergyOffer : undefined;
};

SpecialEnergyOffer.RestoreBoughtReward = function () {
    return { energy: cleverapps.specialEnergyOffer.getEnergyAmount() };
};

SpecialEnergyOffer.TIMEOUT = "24 hours";
SpecialEnergyOffer.ICON_DURATION = "10 minutes";

SpecialEnergyOffer.ENERGY_AMOUNT = 350;
SpecialEnergyOffer.ENERGY_PRICE = 280;

Restorable.BY_TYPE["special_offer"] = new Restorable({
    location: Restorable.LocationContextExpedition,
    find: SpecialEnergyOffer.RestoreFind,
    give: (offer) => offer.processBought(true),
    boughtReward: SpecialEnergyOffer.RestoreBoughtReward
});